import * as React from 'react';

// noinspection JSUnusedGlobalSymbols
const svgList = {
  data: {},
  getter: {
    /**
     * Returns amenity by code
     * If code not found returns an empty string
     *
     * @param {string} code
     * @returns {string}
     */
    getSvg(code) {
      return svgList.data[code];
    }
  }
};

export default svgList;
